import classNames from 'classnames'
import * as React from 'react'
import useSiteMetadata from '../../hooks/use-site-metadata'
import './index.scss'
import { useTranslation } from 'react-i18next'

interface Props {
  centerAlign?: boolean
}

export default function Footer(props: Props) {
  const { centerAlign } = props
  const { title, organization, organizationSite } = useSiteMetadata()
  const { t } = useTranslation()
  return (
    <div
      className={classNames('Footer', {
        'center-align': centerAlign,
      })}
      role="contentinfo"
    >
      <div className="Footer__flex">
        <div>{title}</div>
        <div>
          <span>&#169;&nbsp;</span>
          <span>{new Date().getFullYear()}</span>
          <span>,&nbsp;</span>
          <a href={organizationSite}>{organization}</a>
          <span>&nbsp;{t('allRightsReserved')}</span>
        </div>
      </div>
    </div>
  )
}
